<div class="padding">
  <mat-card>
    <mat-card-content>
      <!-- Main orders table -->
      @if (data.length > 0) {
        <div class="table-container">
          <h3>{{ 'failedOrders.failedOrders' | transloco }}</h3>
          <!-- Orders table -->
          @if (data.length > 0) {
            <table mat-table [dataSource]="data" multiTemplateDataRows>
              <ng-container matColumnDef="referenceNumber">
                <th mat-header-cell *matHeaderCellDef id="referenceNumber"> {{ 'common.labels.refNo' | transloco }} </th>
                <td mat-cell *matCellDef="let order"> {{order.referenceNumber}} </td>
                <td mat-footer-cell *matFooterCellDef class="bold"> {{ 'failedOrders.totalFailedOrders' | transloco }} </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef id="status"> {{ 'common.labels.status' | transloco }} </th>
                <td mat-cell *matCellDef="let order"> {{ order.orderStatusTypeID | enumLabel:'orderStatusType' }} </td>
                <td mat-footer-cell *matFooterCellDef> </td>
              </ng-container>
              <ng-container matColumnDef="jurisdiction">
                <th mat-header-cell *matHeaderCellDef id="jurisdiction"> {{ 'common.labels.juris' | transloco }} </th>
                <td mat-cell *matCellDef="let order"> {{order.displayJurisdiction}} </td>
                <td mat-footer-cell *matFooterCellDef> </td>
              </ng-container>
              <ng-container matColumnDef="orderTypeID">
                <th mat-header-cell *matHeaderCellDef id="orderTypeID"> {{ 'common.labels.type' | transloco }} </th>
                <td mat-cell *matCellDef="let order"> {{ order.orderTypeID | enumLabel:'orderType':order.orderTypeName }} </td>
                <td mat-footer-cell *matFooterCellDef class="bold"> {{ total }} </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="clickable-table-row"
              [routerLink]="['/orders', row.id]" @tableAnimation></tr>
              <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
            </table>
          }
          <!-- End of orders table-->
          <div class="flex-container-right-align">
            <button mat-raised-button color="accent" class="margin-sides-5"
              [attr.aria-label]="'failedOrders.viewAllFailedOrdersButton' | transloco" type="submit" (click)="onViewAll()">
              {{ 'failedOrders.viewAll' | transloco }}
            </button>
          </div>
        </div>
      }
      <!-- End of main orders table-->

      <lib-placeholder iconName="cancel" iconClass="icon-error" [message]="'failedOrders.errorLoadingFailedOrders' | transloco"
      [condition]="(this.repo.error$ | async) ?? false && !loading"></lib-placeholder>
      <lib-placeholder iconName="check_circle" iconClass="icon-success" [message]="'failedOrders.noFailedOrdersFound' | transloco"
      [condition]="!(this.repo.error$ | async) && !loading && data.length === 0"></lib-placeholder>

    </mat-card-content>
  </mat-card>
</div>